import { createFileRoute } from '@tanstack/react-router'

import { AccountPage } from '@/pages/account/Account.page'

export const Route = createFileRoute('/_auth/account')({
  component: AccountPage,
  loader: () => ({ breadcrumbTitle: 'Account' }),
})
